import { render, staticRenderFns } from "./PalletForm.vue?vue&type=template&id=6abf7eb5&"
import script from "./PalletForm.vue?vue&type=script&lang=js&"
export * from "./PalletForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports